import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { Select } from "antd";
// Chemin direct : babel-plugin-import (config-overrides.js, style: true) réécrirait { theme } en antd/es/theme/style, inexistant
import theme from "antd/es/theme";

// Libellé d'un exercice à partir de son année de début : 2026 → « 2026/2027 »
export const exerciceLabel = (annee) => `${annee}/${annee + 1}`;

// Sélecteur d'exercice : années du début d'activité de la société courante à l'année en cours.
// Libellé « Y/Y+1 », valeur = année de début Y.
// Contrôlé (value/onChange) : le propriétaire de l'exercice sélectionné est décidé par le parent.
const ExerciceSelect = ({ value, onChange, disabled, style }) => {
  const societeId = useSelector((state) => state.utilisateur.data?.societe_id);
  // state.societes plutôt que utilisateur_societe : reflète les mises à jour faites dans FormSociete
  const activityStart = useSelector(
    (state) => state.societes.data?.find((s) => s.societe_id === societeId)?.societe_activity_start
  );
  const { token } = theme.useToken();

  // Hors exercice en cours : préfixe et année affichée en rouge gras (la liste déroulante n'est pas concernée)
  const highlightStyle =
    value !== new Date().getFullYear() ? { color: token.colorError, fontWeight: 600 } : undefined;

  const options = useMemo(() => {
    const currentYear = new Date().getFullYear();
    // null (nullable en base) ou année future : seule l'année en cours est proposée
    const validStart = activityStart && activityStart <= currentYear ? activityStart : currentYear;
    // Inclut toujours l'exercice sélectionné : après un changement, societes est vide le temps du rechargement
    const startYear = value ? Math.min(validStart, value) : validStart;
    return Array.from({ length: currentYear - startYear + 1 }, (_, i) => ({
      value: currentYear - i,
      label: exerciceLabel(currentYear - i),
    }));
  }, [activityStart, value]);

  return (
    <Select
      size="large"
      prefix={<span style={highlightStyle}>Exercice</span>}
      labelRender={({ label }) => <span style={highlightStyle}>{label}</span>}
      value={value}
      onChange={onChange}
      disabled={disabled}
      options={options}
      style={style}
    />
  );
};

export default ExerciceSelect;
